var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDashboard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510.034 510.034",
    height: 512,
    viewBox: "0 0 510.034 510.034",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_751_",
    d: "m0 30.399v365.555h238.928v53.681h-149.914v30h332.006v-30h-152.092v-53.681h241.106v-365.555zm480.034 335.555h-450.034v-39.319h210.034v19.66h30v-19.66h210zm-450.034-69.319v-236.236h450.034v236.236z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_759_",
    d: "m142.034 131.226h-15c-39.1 0-70.91 31.81-70.91 70.91 0 39.094 31.81 70.9 70.91 70.9s70.91-31.806 70.91-70.9v-15h-55.91zm23.061 85.909c-5.996 15.153-20.797 25.9-38.061 25.9-22.558 0-40.91-18.348-40.91-40.9 0-17.265 10.751-32.067 25.91-38.062v53.062z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_773_",
    d: "m174.989 83.271h-15v85.91h85.91v-15c0-39.1-31.81-70.91-70.91-70.91zm15 55.909v-23.062c10.512 4.157 18.905 12.55 23.063 23.062z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_774_",
    d: "m291.034 140.135h30v42.045h-30z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_775_",
    d: "m291.034 93.802h30v21.469h-30z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_776_",
    d: "m351.034 140.135h30v42.045h-30z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_781_",
    d: "m351.034 93.802h30v21.469h-30z"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_782_",
    d: "m411.034 140.135h30v42.045h-30z"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_783_",
    d: "m411.034 93.802h30v21.469h-30z"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "XMLID_784_",
    d: "m430.769 200.468-42.334 30.375-35.279-20.09-54.859 33.032 15.474 25.701 39.808-23.969 36.721 20.911 57.958-41.585z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDashboard);
export default __webpack_public_path__ + "static/media/dashboard.2d8e6d20482691cc2b20231e71f70776.svg";
export { ForwardRef as ReactComponent };